import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
import DR_Splash from '../../Assets/Images/DR_Logo.png'
import DR_RED from '../../Assets/Images/RED_Logo.png'
import DR_Logo from '../../Assets/Icons/favicon_2.png'
export default function UI_LoadingScreen({ ID = "Screen_Loading", Type, Title, Text }) {
    const UI = useContext(Context_UI);

    return (
        <>
            {Type == "Splash" ?
                <div className="Screen_Loading" id={ID}>
                    <div className="Screen_Loading_Splash">
                        <span></span>
                        <div className="Screen_Loading_Splash_Window">
                            <div className="Screen_Loading_Splash_Window_Loader"></div>
                            <img src={DR_Splash} loading="lazy" draggable="false" className="Screen_Loading_Splash_Window_Image" id="Screen_Loading_Splash_Window_Image" alt='' />
                            <img src={DR_Logo} loading="lazy" draggable="false" className="Screen_Loading_Splash_Window_Icon" id="Screen_Loading_Splash_Window_Icon" alt='' />
                        </div>
                        <div className="Screen_Loading_Splash_Text">
                            <h1 className="Screen_Loading_Splash_Text_Title" id="Screen_Loading_Splash_Text_Title">
                                {Title ? Title : ""}
                            </h1>
                            <p className="Screen_Loading_Splash_Text_Page" id="Screen_Loading_Splash_Text_Page" >
                                {Text}
                            </p>
                        </div>
                        <span></span>
                        <div className="Screen_Loading_Splash_Copyright">
                            <img src={DR_RED} className="Screen_Loading_Splash_Copyright_Icon" loading="lazy" draggable="false" id="Screen_Loading_Splash_Copyright_Icon" alt='' />
                            <h3 className="Screen_Loading_Splash_Copyright_Text" id="Screen_Loading_Splash_Copyright_Text">

                            </h3>
                        </div>
                    </div>
                </div>
                :
                <div className="Screen_Loading" id={ID}>
                    <div className="Screen_Loading_Plain">
                        <div className="Loader_Square">
                            <div className="Loader_Square_Component"></div>
                            <div className="Loader_Square_Component"></div>
                            <div className="Loader_Square_Component"></div>
                            <div className="Loader_Square_Component"></div>
                        </div>
                        <h2 className="Screen_Loading_Plain_Text">
                            {Text}
                        </h2>
                    </div>
                    
                </div>
            }
        </>
    )
}

